import React from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { Navbar, Sidebar, Footer } from './components';

import {AuthWrapper, Home, About, Cart, Checkout, Error, Private, Products, SingleProduct} from './pages'




function App() {
  return (
  <AuthWrapper>
  <BrowserRouter>
                 <Navbar></Navbar>
                 <Sidebar></Sidebar>
             <Routes>
                <Route path="/" element={<Home></Home>}></Route>
                <Route path="about" element={<About></About>}></Route>
                <Route path="cart" element={<Cart></Cart>}></Route>
                <Route path="checkout" element={<Private><Checkout></Checkout></Private>}></Route>
                <Route path="*" element={<Error></Error>}></Route>
                <Route path="products" element={<Products></Products>}></Route>
                <Route path="products/:id" element={<SingleProduct></SingleProduct>}></Route>
              </Routes>
           <Footer></Footer>
  </BrowserRouter>
  </AuthWrapper>
  )
}

export default App
